// extracted by mini-css-extract-plugin
export default {"dark":"Accordion_dark__8sAj6","accordion":"Accordion_accordion__LcrUg","accordionHeader":"Accordion_accordionHeader__IQnYx","accordionContent":"Accordion_accordionContent__3VpP7"};